// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"586":"f46ca087","636":"f46ca087"}[chunkId] + ".chunk.css";
};